import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import api from '@/utils/httpClient';
import { EpisodeDto, EpisodeForCreationDto, EpisodeForManipulationDto } from '../dtos/Episode';
import { noop } from 'lodash';

export function createEpisode(data: EpisodeForCreationDto) {
  return api.post('/api/episodes', data).then((response) => {
    const responseData = response.data as ApiResponse<EpisodeDto>;

    return responseData.data;
  });
}

export function updateEpisode(episodeId: string, data: EpisodeForManipulationDto) {
  return api
    .put(`/api/episodes/${episodeId}`, data)
    .then((response) => (response.data as ApiResponse<EpisodeDto>).data);
}

export function deleteEpisode(episodeId: string) {
  return api.delete(`/api/episodes/${episodeId}`).then(noop);
}
